export enum PollingStatus {
    Init = 'INIT',
    Launched = 'LAUNCHED',
    InProgress = 'IN_PROGRESS',
    Success = 'SUCCESS',
    PartialFail = 'PARTIAL_FAIL',
    AwaitInput = 'AWAIT_INPUT',
    Fail = 'FAIL',
    Canceled = 'CANCELED',
}

export function getLocalizedPollingStatus(): Record<any, string> {
    return {
        INIT: $localize`:@@status.init:Klaar voor uitvoeren`,
        LAUNCHED: $localize`:@@status.launched:Gestart`,
        IN_PROGRESS: $localize`:@@status.inProgress:Bezig`,
        SUCCESS: $localize`:@@status.success:Succesvol`,
        FAIL: $localize`:@@status.fail:Gefaald`,
    };
}

export const pollingStatusColorCode: Record<any, string> = {
    INIT: 'text-inherit',
    LAUNCHED: 'text-inherit',
    IN_PROGRESS: 'text-inherit',
    SUCCESS: 'text-success',
    FAIL: 'text-danger',
};
